import type { Feature, Geometry } from 'geojson'

import type { SmartSearchFeatureHit } from '../types'

import type { LayerSearchRow } from './buildLayerSearchRows'
import { pickFeatureLabel } from './pickFeatureLabel'

export type ServerSearchHit = {
  feature_id: string | number
  layer_id: number
  geometry: Geometry
  properties?: Record<string, unknown> | null
}

export function serverHitToFeatureHit(
  hit: ServerSearchHit,
  layerRow: LayerSearchRow | undefined,
  key: string,
): SmartSearchFeatureHit {
  const feature: Feature = {
    type: 'Feature',
    id: hit.feature_id,
    geometry: hit.geometry,
    properties: hit.properties ?? {},
  }
  return {
    kind: 'feature',
    key,
    layerId: hit.layer_id,
    layerName: layerRow?.layerName ?? `Couche ${hit.layer_id}`,
    label: pickFeatureLabel(feature),
    feature,
    layerCreatorUserId: layerRow?.layerCreatorUserId ?? null,
    layerCreatorUsername: layerRow?.layerCreatorUsername ?? null,
  }
}
